class NotificationSystem {

    constructor(date) {

        var that = this;

        this.WORLD_COMPLETION_BY_CONTENT = "7";

        this.socket = this.getSocket("user_world_id=" + user.user_world_id);
        this.canShowNotifications = true;
        this.notificationArray = new Array();
        this.isConnected = false;
        this.notificationsTypes = _.keys(new NotificationTypes().getNotificationTypes());

        this.socket.on('connect', function() {
            that.isConnected = true;
            that.socket.emit(SocketEvents.LOGIN_REQUEST(), JSON.stringify({user_world_id: user.user_world_id, email: user.email, auth: api.getHeader()}));

            that.socket.off(SocketEvents.LOGIN_RESPONSE()).on(SocketEvents.LOGIN_RESPONSE(), function() {

                if (documentationScreenController.documentationNew.articleDocument.getIsEditing()) {
                    that.socket.emit(SocketEvents.BIND_EDITOR_CLIENT_REQUEST(), JSON.stringify({token: documentationScreenController.documentationNew.articleDocument.getEditorToken()}));
                }

            });

        });

        // Si se desconecta el socket intentara reconectarse periodicamente (para fallos temporales de desconexion con node)
        this.socket.on('disconnect', function() {

            that.isConnected = false;
            let connectionMaxRetries = 10;
            let connectionRetries = 0;
            let interval = window.setInterval(function() {
                if (that.isConnected || connectionRetries >= connectionMaxRetries) {
                    clearInterval(interval);
                    interval = null;
                    return;
                }
                connectionRetries++;
                that.socket.connect();
            }, 5000);
        });

        // Nos suscribimos a las notificaciones en tiempo real
        this.socket.on('NEW_NOTIFICATION', function (notification) {
            const hasNotificationIcon = $("#open-notifications-button > .has-notifications");
            const hasNotNotificationIcon = $("#open-notifications-button > .has-not-notifications");

            if (that.notificationsTypes.indexOf(notification.type) >= 0 && hasNotNotificationIcon.is(":visible")) {
                hasNotNotificationIcon.hide();
                hasNotificationIcon.show();

                // Connected with User Store, change if has notifications
                window.reactZustandBridge.changeNotificationState(true);
            }

            that.notificationArray.push(notification);
            that.checkForNotifications();
        });

        // Consultamos las notificaciones que hubieran de antes al hacer login
        api.loginNotifications(world.token ?? world.world_token,date,0,10);

    }

    getSocket(query = '') {
        if(!this.socket) {

            if(query.length) {
                this.socket = io.connect(node_url, {query: query});
            } else {
                this.socket = io.connect(node_url);
            }

        }
        return this.socket;
    }

    checkForNotifications(){
        let that = this;

        if (this.notificationArray.length) {
            if (this.canShowNotifications) {
                this.canShowNotifications = false;
                var notification = this.notificationArray.shift();

                if (notification.type == 'NEW_CHALLENGE' || notification.type == 'CHALLENGE_FINISHED') {
                    api.getChallengeInfo(world.token, notification.gI, notification.type,'close');
                }

                if (notification.type == 'QUESTION_ACCEPTED' || notification.type == 'QUESTION_REJECTED') {
                    api.getQuestionInfo(world.token,notification.qI,false);
                }

                if (notification.type == 'LEVEL_UP' || notification.type == 'LEVEL_DOWN') {
                    api.levelChange(world.token, notification.lI, function(response) {

                        let result = response.result;
                        result.action = notification.type;

                        let template = Handlebars.compile($("#levelUpModal").html());

                        $("#modalContainer").html(template(result)).modal('show');

                        $(document).one('click', '.modal-close-btn, .modal-accept-btn', function() {
                            $("#modalContainer").modal('hide').empty();
                            $(document).off('click', '.modal-close-btn, .modal-accept-btn');

                            that.canShowNotifications = true;
                            that.checkForNotifications();
                        });

                    });
                }

                if (notification.type == 'COMMENT_EDITED' || notification.type == 'COMMENT_DELETED') {
                    var notificationTitle = '';
                    var notificationText = '';

                    if(notification.type == 'COMMENT_EDITED') {
                        notificationTitle = '<strong>' + sprintf(Translator.trans('TR_COMENTARIO_EDITADO_TITLE'), notification.document_name) + '</strong>';
                        notificationText = Translator.trans("TR_COMENTARIO_ORIGINAL") + '<br><i>"' + notification.old_comment + '"</i>' +
                            '<br><br>' + Translator.trans("TR_COMENTARIO_REVISADO") + '<br><i>"' + notification.comment + '"</i>' +
                            '<br><br>' + sprintf(Translator.trans('TR_MOTIVO_DE_LA_EDICION'), notification.reason);
                    } else {
                        notificationTitle = '<strong>' + sprintf(Translator.trans('TR_COMENTARIO_ELIMINADO_TITLE'), notification.document_name) + '</strong>';
                        notificationText = '<i>"' + notification.comment + '"</i>' +
                            '<br><br>' + sprintf(Translator.trans('TR_MOTIVO_DE_LA_ELIMINACION'), notification.reason);
                    }

                    swal({
                        title: notificationTitle,
                        text: notificationText,
                        html: true,
                        confirmButtonText: Translator.trans('TR_ACEPTAR'),
                    }, () => {
                        setTimeout(() => {
                            this.canShowNotifications = true;
                            this.checkForNotifications();
                        }, 500);
                    });

                    api.markNotificationRead(world.token);
                }

                if (notification.type == 'ACHIEVEMENT') {
                    api.newAchievment(world.token,notification.aI);
                }

                if(notification.type == 'WORLD_COMPLETED'){
                    let template = Handlebars.compile($("#worldCompletedNotification").html());
                    $("#modalContainer").html(template(notification)).modal('show');

                    $(document).one('click', '.result-button', function() {
                        $("#modalContainer").modal('hide').empty();
                    });

                    // Si es LMS y el modo de completitud es por contenido enviar estado completado
                    if (world.is_lms && notification.completion_mode === that.WORLD_COMPLETION_BY_CONTENT) {
                        const data = {
                            msj: "complete",
                            result: {
                                user: {
                                    total_time: user.total_time,
                                    world_completed: true,
                                    preguntas_a_la_primera: 100,
                                }
                            }
                        };

                        window.parent.postMessage(data, "*");
                    }
                }

                api.getPendingChallenges(world.token,false);
            }
        }
    }
}